import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import Loader from "../Loader";
import useInfiniteScroll from "../hooks/useInfiniteScroll";

export default function Grid(props) {
  const {
    children,
    page = 1,
    pageCount = 1,
    loading = false,
    onPaginate = null,
  } = props;
  const ref = useRef();
  const [entry] = useInfiniteScroll(ref);
  useEffect(() => {
    if (entry.isIntersecting && page < pageCount && onPaginate) {
      onPaginate(page + 1);
    }
  }, [entry]);
  return (
    <section>
      <div className={styles.container}>{children}</div>
      {onPaginate !== null && (
        <div ref={ref} className={styles.infiniteContainer}>
          {loading && <Loader />}
        </div>
      )}
    </section>
  );
}
